module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Midi-3cbb4ad6836a8862cf9032a517f43654.svg";